import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IStatus } from '@obvious.tech/constellation'

export const Status = defineEntity('Status', {
  endpoint: 'alarms/api/Status',
  schema: SNoop<IStatus>(),
})
